import * as React from "react"
import injectSheet from "react-jss"
import cn from "classnames"
import compose from "recompose/compose"
import withProps from "recompose/withProps"
import { withi18n } from "@/helpers/hoc/withi18n"
import { color } from "@xingternal/360-styles/helpers"
import { Text } from "@xingternal/360-components"
import { ErrorImage } from "./error.js"
import { onlyfyFullTheme } from "@xingternal/rebranding-adapter"

const styles = {
  container: { composes: "flex flex-column items-center pb32 pt48" },
  img: { composes: "mb24" },
  message: { composes: "mb16 gray-60" },
  action: {
    color: ({ isActionable }) =>
      isActionable ? color("gray-15") : onlyfyFullTheme.colors.linkText,
    cursor: ({ isActionable }) => (!isActionable ? "pointer" : "default"),
    pointerEvents: ({ isActionable }) => isActionable && "none",
  },
}

const i18n = {
  errorMessageDefault: "360_RECRUITER_INSIGHTS_ERROR_MESSAGE_DEFAULT",
  errorActionDefault: "360_RECRUITER_INSIGHTS_ERROR_ACTION_DEFAULT",
}

const ErrorView = ({ actionText, action, classes, className, message }) => (
  <div className={cn(classes.container, className)}>
    <ErrorImage className={classes.img} />
    <Text size={13} className={classes.message}>
      {message}
    </Text>
    <Text size={15} bold className={classes.action} onClick={action}>
      {actionText}
    </Text>
  </div>
)

const enhance = compose(
  withi18n(i18n),
  withProps(({ errorMessageDefault, errorActionDefault, ...rest }) => ({
    message: errorMessageDefault,
    actionText: errorActionDefault,
    ...rest,
  })),
  injectSheet(styles),
)

export const EnhancedErrorView = enhance(ErrorView)
export const StyledErrorView = injectSheet(styles)(ErrorView)
export default ErrorView
